const GENERIC_ERROR = 'Something bad happened.'

export const getErrorMessage = (e: unknown): string =>
  e instanceof Error ? e.message : GENERIC_ERROR
